import store from '../../../store'
window.TTN_REMOVE =  new Vue({
    store,
    el: '#ttn_remove',
    name : "TTN_REMOVE",
    created () {
        EventBus.$on('remove_ttn',this.remove_ttn)
    },

    methods : {
        remove_ttn(id) {
            const is_ok = confirm_imc('Виконати ?');
            is_ok.then(res => {
                IMC_CORE.showloading();
                api.delete('/nfc/ttn/' + id).then(({data}) => {
                    if (data.status == "operation_success") {
                        window.location.reload();
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            });
        },
    },
})


